import {
  GET_GROUPS,
  GET_GROUP,
  GET_GROUP_USERS,
  CREATE_GROUP,
  EDIT_GROUP,
  ADD_NEW_USER_TO_GROUP,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  groups: [],
  group: {},
  group_users: [],
  is_fetching: false,
  getting_group: false,
  creating_group: false,
  editting_group: false,
  adding_new_user_to_group: false,
};

export const groupReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(GET_GROUPS):
      return {
        ...state,
        is_fetching: true,
      };
    case failedType(GET_GROUPS):
      return {
        ...state,
        is_fetching: false,
      };
    case succeedType(GET_GROUPS):
      return {
        ...state,
        is_fetching: false,
        groups: action.groups,
      };
    case requestType(GET_GROUP):
      return {
        ...state,
        getting_group: true,
      };
    case failedType(GET_GROUP):
      return {
        ...state,
        getting_group: false,
      };
    case succeedType(GET_GROUP):
      return {
        ...state,
        getting_group: false,
        group: action.group,
      };
    case requestType(GET_GROUP_USERS):
      return {
        ...state,
        getting_group_users: true,
      };
    case failedType(GET_GROUP_USERS):
      return {
        ...state,
        getting_group_users: false,
      };
    case succeedType(GET_GROUP_USERS):
      return {
        ...state,
        getting_group_users: false,
        group_users: action.group_users,
      };
    case requestType(CREATE_GROUP):
      return {
        ...state,
        creating_group: true,
      };
    case failedType(CREATE_GROUP):
      return {
        ...state,
        creating_group: false,
      };
    case succeedType(CREATE_GROUP):
      return {
        ...state,
        creating_group: false,
      };
    case requestType(EDIT_GROUP):
      return {
        ...state,
        editting_group: true,
      };
    case failedType(EDIT_GROUP):
      return {
        ...state,
        editting_group: false,
      };
    case succeedType(EDIT_GROUP):
      return {
        ...state,
        editting_group: false,
      };
    case requestType(ADD_NEW_USER_TO_GROUP):
      return {
        ...state,
        adding_new_user_to_group: true,
      };
    case failedType(ADD_NEW_USER_TO_GROUP):
      return {
        ...state,
        adding_new_user_to_group: false,
      };
    case succeedType(ADD_NEW_USER_TO_GROUP):
      return {
        ...state,
        adding_new_user_to_group: false,
      };
    default:
      return state;
  }
};
